import { RESTRICTED_DAYS_END, RESTRICTED_DAYS_START } from './app-global-values';

export const isBlockedRestricted = date => {
  if (!date) {
    date = new Date(Date.now());
  }
  if (RESTRICTED_DAYS_END === null) {
    return false;
  }
  const dateForComparison = date.getTime();
  if (RESTRICTED_DAYS_START === null) {
    return dateForComparison < RESTRICTED_DAYS_END.getTime();
  }
  return dateForComparison > RESTRICTED_DAYS_START.getTime() && dateForComparison < RESTRICTED_DAYS_END.getTime();
};
